import React, {useState} from 'react';
import {Box, ButtonBase, Popover, Stack, Tooltip, Typography} from "@mui/material";
import {CLASS_PALETTE, classColor} from "../../library/ClassColors";

interface ClassColorSwatchProps {
    value: string
    color?: string
    didUpdateColor: (color?: string) => void
}

const swatchSx = (swatch: string, selected: boolean) => ({
    width: 24,
    height: 24,
    borderRadius: "50%",
    bgcolor: swatch,
    border: 2,
    borderColor: selected ? "text.primary" : "transparent",
})

function ClassColorSwatch({value, color, didUpdateColor}: ClassColorSwatchProps) {
    const [anchor, setAnchor] = useState<HTMLElement | null>(null)

    const resolved = color ?? classColor(value)

    const select = (swatch?: string) => {
        setAnchor(null)
        if (swatch !== color) didUpdateColor(swatch)
    }

    return (
        <>
            <Tooltip title="Class color">
                <ButtonBase onClick={event => setAnchor(event.currentTarget)}
                            sx={{...swatchSx(resolved, false), borderColor: "divider"}}/>
            </Tooltip>

            <Popover open={Boolean(anchor)}
                     anchorEl={anchor}
                     onClose={() => setAnchor(null)}
                     anchorOrigin={{vertical: "bottom", horizontal: "left"}}>
                <Stack spacing={1} sx={{p: 1.5, maxWidth: 176}}>
                    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
                        {CLASS_PALETTE.map(swatch => (
                            <ButtonBase key={swatch}
                                        onClick={() => select(swatch)}
                                        sx={swatchSx(swatch, swatch === color)}/>
                        ))}
                    </Stack>
                    <ButtonBase onClick={() => select(undefined)}
                                sx={{justifyContent: "flex-start", borderRadius: 1, px: 0.5}}>
                        <Box sx={{...swatchSx(classColor(value), color === undefined), mr: 1}}/>
                        <Typography variant="caption" color="text.secondary">Auto</Typography>
                    </ButtonBase>
                </Stack>
            </Popover>
        </>
    )
}

export default ClassColorSwatch;
